import React, { FC, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { CheckBox, NumberBox, SelectBox, TextArea } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import {
  useCreateTransportMutation,
  useEditTransportMutation,
  useLazyGetTransportDetailQuery,
  useLazyGetTransportTypesQuery,
} from 'bus/transport/transport';
import { TransportItemFull } from 'bus/transport/types';

type DetailModalRoleProps = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const initialForm = {
  id: null,
  contractorId: null,
  transportType: null,
  comment: '',
  vinCode: '',
  number: '',
  customName: '',
  modelId: null,
  quantity: undefined,
  weight: 0,
  isDeleted: false,
  calculatePayment: false,
};

const DetailModalRole: FC<DetailModalRoleProps> = (props) => {
  const [getTransportDetail] = useLazyGetTransportDetailQuery();
  const [getTransportTypes, { data }] = useLazyGetTransportTypesQuery();
  const [createTransport, { isLoading: isCreateLoading }] = useCreateTransportMutation();
  const [editTransport, { isLoading: isEditLoading }] = useEditTransportMutation();

  let createTransportGroupRef = useRef<any>(null);
  let createTransportGroupValidationRef = useRef<any>(null);

  const [form, setForm] = useState<TransportItemFull>(initialForm);
  const [loading, setLoading] = useState(false);

  const contractorDataStore: DataSource = useMemo(
    () => $createDataSource('/v1/Contractor', 'id', { pageSize: 10, paginate: true }),
    [],
  );

  const modelsDataStore: DataSource = useMemo(
    () => $createDataSource('/v1/TransportModel', 'id', { pageSize: 10, paginate: true }),
    [],
  );

  const handleSubmit = async (e: any) => {
    setLoading(true);
    e.preventDefault && e.preventDefault();
    if (form.transportType === 2) {
      form.quantity = 0;
    }
    if (createTransportGroupValidationRef.current.instance.validate().isValid) {
      const maskNumber = form.number.slice(0, 6) + ' ' + form.number.slice(6, 9);
      if (props.id) {
        await editTransport({ ...form, number: maskNumber }).then((resp: any) => {
          if (isSuccess(resp)) {
            props.changeVisible(false);
            props.refresh();
          }
        });
      } else {
        await createTransport({ ...form, id: 0, number: maskNumber }).then((resp: any) => {
          if (isSuccess(resp)) {
            props.changeVisible(false);
            props.refresh();
          }
        });
      }
    }
    setLoading(false);
  };

  const onShown = async () => {
    const typesRes = await getTransportTypes();
    if (isSuccess(typesRes)) {
      const data: any = 'data' in typesRes ? (typesRes as any).data : (typesRes as any);
      setForm((prev) => ({ ...prev, transportListType: data }));
    }
    createTransportGroupValidationRef.current.instance.reset();
    if (props.id) {
      let result = await getTransportDetail({ id: props.id });
      if (isSuccess(result)) {
        const data: any = 'data' in result ? (result as any).data : (result as any);
        const normalized = { ...data, number: data.number.replaceAll(' ', '') };
        setForm((prev) => ({ ...prev, ...normalized }));
      }
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createTransportGroupValidationRef.current.instance.reset();
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title={'Транспорт'}
        width={700}
        onShowing={() => onShown()}
        onHidden={() => onHidden()}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createTransportGroupValidationRef}>
                <Form id="test-transport" formData={form} ref={createTransportGroupRef}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Контрагент" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите"
                            mode="search"
                            searchEnabled
                            value={form.contractorId}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, contractorId: e }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={contractorDataStore}
                          >
                            <Validator>
                              <RequiredRule message="Выберите контрагента" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Тип транспорта" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите тип"
                            mode="text"
                            value={form.transportType}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, transportType: e, customName: '' }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={data}
                          >
                            <Validator>
                              <RequiredRule message="Выберите тип транспорта" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Номер" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Введите номер"
                            mode="text"
                            value={form.number}
                            onValueChange={(e: any) => {
                              setForm((prev) => ({ ...prev, number: e }));
                            }}
                            mask="L 000 LL 009"
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Номер" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>

                        <AppFiledBox label="Марка" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите"
                            value={form.modelId}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, modelId: e }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={modelsDataStore}
                          >
                            <Validator>
                              <RequiredRule message="Выберите контрагента" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                        {form.transportType !== 2 && (
                          <AppRow>
                            <AppGroup col={12}>
                              <AppFiledBox label={form.transportType === 0 ? 'Метраж' : 'Объём'} labelTop>
                                <NumberBox
                                  stylingMode="underlined"
                                  placeholder={form.transportType === 0 ? 'Введите метраж' : 'Введите объём'}
                                  //mode="number"
                                  format="###0.##"
                                  value={form.quantity}
                                  onValueChanged={(e: any) => {
                                    setForm((prev) => ({ ...prev, quantity: e.value }));
                                  }}
                                >
                                  <Validator>
                                    <RequiredRule message="Заполните поле объём" />
                                  </Validator>
                                </NumberBox>
                              </AppFiledBox>
                            </AppGroup>
                          </AppRow>
                        )}
                        <AppFiledBox label="Вес" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Введите вес"
                            //mode="number"
                            format="###0.##"
                            value={form.weight}
                            onValueChanged={(e: any) => {
                              setForm((prev) => ({ ...prev, weight: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле вес" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>

                        <AppFiledBox label="Vin-code2" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Введите vin-code"
                            value={form.vinCode}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, vinCode: e.event.currentTarget.value }));
                            }}
                          ></TextBox>
                        </AppFiledBox>
                        {form.transportType === 0 && (
                          <AppFiledBox label="Доп. наименование" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="Введите Доп. наименование"
                              value={form.customName}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, customName: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        )}

                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          ></TextArea>
                        </AppFiledBox>
                        {form.transportType === 0 && (
                          <AppFiledBox label="" labelTop>
                            <CheckBox
                              value={form.calculatePayment}
                              text="Считать оплату"
                              onValueChanged={(e) => setForm((prev) => ({ ...prev, calculatePayment: e.value }))}
                            />
                          </AppFiledBox>
                        )}
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => props.changeVisible(false)}
                  disabledSubmit={loading || isCreateLoading || isEditLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
